import script from "./Documents.vue?vue&type=script&setup=true&lang=ts"
export * from "./Documents.vue?vue&type=script&setup=true&lang=ts"

export default script